<template>
  <div>
    <p v-if="user">{{ user.firstName }} {{ user.lastName }} : <strong>{{ user.email }}</strong></p>
  </div>
</template>
<script>
export default {
  name: 'contact',
  components: {},
  props: ['user'],
  mounted() {},
  methods: {
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
};
</script>
